import React, { useMemo, useRef, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import DataPage from './pages/DataPage';
import TitleDetailPage from './pages/TitleDetailPage';
import SignalsPanel from './components/SignalsPanel';
import MouseTrail from './components/MouseTrail';
import VoiceAssistant from './components/VoiceAssistant';
import LoginGate from './components/LoginGate';
import { AnalyticsProvider } from './recs/analytics';
import { personas } from './data/personas';

// A near-silent WAV, used to unlock this <audio> element for playback within the
// user gesture that opens the voice assistant (see onOpenVoice below) — the actual
// TTS reply is set on this same element seconds later, well after the record/
// transcribe/LLM round trip, by which point some browsers (notably Safari) no
// longer honor a fresh, gesture-less call to play().
const SILENT_AUDIO_SRC = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';

function App() {
  const [activeId, setActiveId] = useState(personas[0].user.user_id);
  const [voiceOpen, setVoiceOpen] = useState(false);
  const voiceAudioRef = useRef<HTMLAudioElement>(null);

  const activePersona = useMemo(
    () => personas.find((p) => p.user.user_id === activeId) ?? personas[0],
    [activeId]
  );

  return (
    <LoginGate>
      <BrowserRouter>
        <AnalyticsProvider userId={activeId}>
          <div className="App">
            <Header
              personas={personas}
              activeId={activeId}
              onSelect={setActiveId}
              onOpenVoice={() => {
                const audioEl = voiceAudioRef.current;
                if (audioEl) {
                  audioEl.src = SILENT_AUDIO_SRC;
                  audioEl.play().catch(() => {});
                }
                setVoiceOpen(true);
              }}
            />
            <Routes>
              <Route path="/" element={<HomePage persona={activePersona} />} />
              <Route path="/title/:titleId" element={<TitleDetailPage persona={activePersona} />} />
              <Route path="/data" element={<DataPage activeUserId={activeId} />} />
            </Routes>
          </div>
          <MouseTrail />
          <audio ref={voiceAudioRef} hidden />
          <VoiceAssistant
            persona={activePersona}
            open={voiceOpen}
            onClose={() => setVoiceOpen(false)}
            audioRef={voiceAudioRef}
          />
          <SignalsPanel userId={activeId} />
        </AnalyticsProvider>
      </BrowserRouter>
    </LoginGate>
  );
}

export default App;
